import commonSocket from '@/commonSocket';
import toast from '@/services/toast';

export default {
    data() {
        return {
            typingUserInfoState: null,
            typingTimeout: null,
            isTyping: false,

            selection_type: 'press_enter',
            messageContentDraftValue: '',
            messageFeatureStates: false,
            suggestionUserListState: false,
            suggestionUserListData: {
                handle: ''
            },
            textFieldFinalHeight: 0,

            replyMessageData: null,
            replyMsgAlertState: false,
            messageIdForReply: ''
        };
    },

    methods: {
        suggestionListPopupClosed() {
            this.suggestionUserListStateForFileAttach =
                false;

            this.suggestionUserListState = false;
            this.suggestionUserListData.handle = '';
        },

        getMessageInputElement() {
            const composer =
                this.$refs.messageComposer;

            if (
                !composer ||
                typeof composer.getInputElement !==
                    'function'
            ) {
                return null;
            }

            return composer.getInputElement();
        },

        focusMessageInput() {
            const composer =
                this.$refs.messageComposer;

            if (
                composer &&
                typeof composer.focusInput ===
                    'function'
            ) {
                composer.focusInput();
            }

            return this.getMessageInputElement();
        },

        focusFileMessageInput() {
            const composer =
                this.$refs.fileUploadComposer;

            if (
                composer &&
                typeof composer.focusInput ===
                    'function'
            ) {
                composer.focusInput();
            }
        },

        selectedOptionMethod(option) {
            this.selection_type = option;
            this.messageFeatureStates = false;
        },

        messageFeatureStatesMethod() {
            this.messageFeatureStates =
                !this.messageFeatureStates;
        },

        closeMessageFeatureMenu() {
            this.messageFeatureStates = false;
        },

        handleMessageKeydown(event) {
            if (
                event.key === 'PageUp' ||
                event.key === 'PageDown'
            ) {
                const cursorPosition =
                    event.key === 'PageUp'
                        ? 0
                        : event.target.value.length;

                event.preventDefault();

                event.target.setSelectionRange(
                    cursorPosition,
                    cursorPosition
                );

                return;
            }

            if (
                this.selection_type === 'press_enter' &&
                event.key === 'Enter' &&
                !event.shiftKey &&
                !event.isComposing &&
                event.keyCode !== 229
            ) {
                event.preventDefault();
                this.sendMessage();
            }
        },

        handleMessageInput(event) {
            const value = event.target.value;

            this.messageContentDraftValue = value;
            this.autoResize(event);

            this.suggestionUserListState = Boolean(
                this.selectedRoomInfo &&
                this.selectedRoomInfo.is_group_chat &&
                /(^|\s)@[^\s@]*$/.test(value)
            );

            if (value.trim()) {
                this.notifyTyping();
            } else {
                this.stopTypingActivity(
                    this.selectedActvRoomId
                );
            }
        },

        notifyTyping() {
            const roomId = this.selectedActvRoomId;

            if (!roomId) {
                return;
            }

            this.emitTyping(roomId);
            this.isTyping = true;

            if (this.typingTimeout) {
                clearTimeout(this.typingTimeout);
            }

            this.typingTimeout = setTimeout(() => {
                if (
                    String(roomId) ===
                    String(this.selectedActvRoomId)
                ) {
                    this.emitStopTyping(roomId);
                    this.isTyping = false;
                }

                this.typingTimeout = null;
            }, 2000);
        },

        stopTypingActivity(roomId) {
            if (this.typingTimeout) {
                clearTimeout(this.typingTimeout);
                this.typingTimeout = null;
            }

            if (this.isTyping && roomId) {
                this.emitStopTyping(roomId);
            }

            this.isTyping = false;
        },

        emitTyping(roomId) {
            commonSocket.emit({
                type: 'TypingEventForChat',
                message: 'typing',
                ChatRoomId: roomId
            });
        },

        emitStopTyping(roomId) {
            commonSocket.emit({
                type: 'TypingEventForChat',
                message: 'stop',
                ChatRoomId: roomId
            });
        },

        insertEmojiMethod(emoji) {
            this.messageContentDraftValue += emoji;

            this.$nextTick(() => {
                const input =
                    this.focusMessageInput();

                if (input) {
                    this.autoResize({
                        target: input
                    });

                    this.notifyTyping();
                }
            });
        },

        sendMessage() {
            const content =
                this.messageContentDraftValue.trim();

            if (!content || !this.selectedRoomInfo) {
                return;
            }

            if (!this.isChatSocketOpen()) {
                toast.error(
                    'Chat is reconnecting. Please try again in a moment.'
                );
                return;
            }

            const payload = {
                type: 'chat_message',
                message: {
                    content
                }
            };

            if (this.messageIdForReply) {
                payload.message.reply_to =
                    this.messageIdForReply;
            }

            if (!this.sendChatSocketPayload(payload)) {
                toast.error(
                    'The message could not be sent. Please try again.'
                );
                return;
            }

            this.messageContentDraftValue = '';
            this.suggestionUserListState = false;
            this.cancelReplyMessageOnChatMethod(false);

            this.stopTypingActivity(
                this.selectedActvRoomId
            );

            this.$nextTick(() => {
                this.resetAutoResizeMethod();
            });
        },

        resetAutoResizeMethod() {
            const input =
                this.getMessageInputElement();

            if (input) {
                input.style.height = '35px';
            }

            this.textFieldFinalHeight =
                this.replyMsgAlertState
                    ? 284
                    : 236;

            this.setMessagesBoxHeight(
                this.textFieldFinalHeight
            );
        },

        autoResize(event) {
            const input = event && event.target;

            if (!input) {
                return;
            }

            input.style.height = '35px';

            const inputHeight = Math.min(
                input.scrollHeight,
                80
            );

            input.style.height = `${inputHeight}px`;

            const baseHeight =
                this.replyMsgAlertState
                    ? 249
                    : 201;

            const calculatedHeight =
                baseHeight + inputHeight;

            this.textFieldFinalHeight =
                calculatedHeight > 284
                    ? calculatedHeight - 4
                    : calculatedHeight;

            this.setMessagesBoxHeight(
                this.textFieldFinalHeight
            );
        },

        replyMessageOnChatMethod(message) {
            if (!message) {
                return;
            }

            this.replyMessageData = message;
            this.replyMsgAlertState = true;
            this.messageIdForReply = message.id;

            this.$nextTick(() => {
                const input =
                    this.focusMessageInput();

                if (input) {
                    this.autoResize({
                        target: input
                    });
                }
            });
        },

        cancelReplyMessageOnChatMethod(resize) {
            this.messageIdForReply = '';
            this.replyMessageData = null;
            this.replyMsgAlertState = false;

            if (resize !== false) {
                this.$nextTick(() => {
                    const input =
                        this.getMessageInputElement();

                    if (input) {
                        this.autoResize({
                            target: input
                        });
                    }
                });
            }
        }
    }
};
